"use client";

import { Cross2Icon } from "@radix-ui/react-icons";
import { Table } from "@tanstack/react-table";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
//import { DataTableViewOptions } from "@/app/(app)/examples/tasks/components/data-table-view-options";

//import { priorities, statuses } from "../data/data";
import { DataTableFacetedFilter } from "./data-table-faceted-filter";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
  config: {
    search: {
      placeholder: string;
      accessor: string;
    };
    columns: Array<{
      title: string;
      accessor: string;
      options: Array<{
        label: string;
        value: string;
        icon?: React.ComponentType;
        className?: string;
      }>;
    }>;
  };
}

export function DataTableToolbar<TData>({
  table,
  config,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder={config?.search?.placeholder}
          value={
            (table
              .getColumn(config?.search?.accessor)
              ?.getFilterValue() as string) ?? ""
          }
          onChange={(event) =>
            table
              .getColumn(config?.search?.accessor)
              ?.setFilterValue(event.target.value)
          }
          className="h-8 w-[150px] lg:w-[250px]"
        />

        {config.columns?.map((column: any) => {
          return (
            <DataTableFacetedFilter
              // column={table.getColumn(column.accessor)}
              column={table.getColumn(column.accessor)}
              title={column.title}
              options={column.options}
              key={column.accessor}
            />
          );
        })}

        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
      {/* <DataTableViewOptions table={table} /> */}
    </div>
  );
}
